module.exports = __webpack_public_path__ + "static/media/white_halftone_desktop.3b4c2d6e.png";